import { jsx as _jsx } from "react/jsx-runtime";
import { StyledAnimatedTextComponent } from "./animated-text-component.scss";
const AnimatedTextComponent = ({ text = "" })=>{
    const words = text === null || text === void 0 ? void 0 : text.split('');
    return /*#__PURE__*/ _jsx(StyledAnimatedTextComponent, {
        words: words,
        className: "animated-text-component",
        children: words.map((word, index)=>/*#__PURE__*/ _jsx("span", {
                className: "animated-word",
                children: word === " " ? "\u00A0" : word
            }, index))
    });
};
export default AnimatedTextComponent;
